module.exports = __webpack_public_path__ + "static/r2c3-dec916453b07f59ec0c35ec68903a417.png";